import { render, staticRenderFns } from "./MainVideoWrapper.vue?vue&type=template&id=8e85e268"
import script from "./MainVideoWrapper.vue?vue&type=script&lang=js"
export * from "./MainVideoWrapper.vue?vue&type=script&lang=js"
import style0 from "./MainVideoWrapper.vue?vue&type=style&index=0&id=8e85e268&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports